<template>
  <div>
    <h1 class="text-3xl font-bold text-blue-800">Mairies</h1>

    <div class="grid filter-container p-4 m-4" style="justify-content: space-evenly;">
      <div class="col-auto">
        <label for="searchQuery" class="block mb-1">Recherche par Nom</label>
        <p-input 
          id="searchQuery" 
          v-model="searchQuery" 
          placeholder="Rechercher une mairie" 
        />
      </div>
      <div class="col-auto">
        <p-select
          label="Période"
          optionLabel="text"
          placeholder="Sélectionnez une période"
          :options="filterOptions"
          v-model="selectedFilter"
          optionValue="value"
          @change="onPeriodFilterChange"
          :showClear="true"
        />
      </div>
      <div v-if="selectedFilter === 'custom'" class="grid custom-filter-container p-4">
        <div class="col-auto mr-4">
          <p-calendar 
            v-model="startDate" 
            label="Date de début" 
            placeholder="Date de début" 
            dateFormat="dd/mm/yy" 
          />
        </div>
        <div class="col-auto mr-4">
          <p-calendar 
            v-model="endDate" 
            label="Date de fin" 
            placeholder="Date de fin" 
            dateFormat="dd/mm/yy" 
          />
        </div>
        <button @click="applyCustomFilter" class="p-button p-button-sm">Valider</button>
      </div>
    </div>
    <div class="p-4">
      <DataTable :value="filteredStatistics" paginator :rows="10" class="p-datatable-sm" responsiveLayout="scroll" v-if="filteredStatistics.length">
        <Column field="name" header="Mairies" style="width: 50%"></Column>
        <Column field="births" header="Naissances" style="width: 25%"></Column>
        <Column field="deaths" header="Décès" style="width: 25%"></Column>
      </DataTable>
      <p v-else>Aucune donnée disponible pour le moment.</p>
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PSelect from "@/components/form/form-select/p-select.vue";
import PCalendar from "primevue/calendar";
import PInput from "primevue/inputtext";
import { defineComponent, computed, ref, onMounted, watch } from "vue";
import { useStatisticsStore } from "@/store/statistics";

export default defineComponent({
  name: "MairiesPage",
  components: {
    DataTable,
    Column,
    PSelect,
    PCalendar,
    PInput,
  },
  setup() {
    const statisticsStore = useStatisticsStore();
    const selectedFilter = ref(null);
    const startDate = ref(null);
    const endDate = ref(null);
    const searchQuery = ref("");

    const filterOptions = ref([
      { text: "Mois dernier", value: "lastMonth" },
      { text: "Dernier trimestre", value: "lastQuarter" },
      { text: "Dernier semestre", value: "lastSemester" },
      { text: 'Année en cours', value: 'CurrentYear' },
      { text: 'Année en précédente', value: 'PreviousYear' },
      { text: "Personnalisé", value: "custom" },
    ]);

    onMounted(async () => {
      await statisticsStore.loadAllData(); 
    });

    const applyCustomFilter = async () => {
      const startDateStr = startDate.value ? startDate.value.toISOString() : null;
      const endDateStr = endDate.value ? endDate.value.toISOString() : null;
      await statisticsStore.applyDateFilter(startDateStr, endDateStr);
    };

    const onPeriodFilterChange = async () => {
      if (selectedFilter.value === "lastMonth") {
        await statisticsStore.filterLastMonth();
      } else if (selectedFilter.value === "lastQuarter") {
        await statisticsStore.filterLastQuarter();
      } else if (selectedFilter.value === "lastSemester") {
        await statisticsStore.filterLastSemester();
      } else if (selectedFilter.value === 'CurrentYear') {
        await statisticsStore.filterCurrentYear();
      } else if (selectedFilter.value === 'PreviousYear') {
        await statisticsStore.filterPreviousYear();
      } else if (selectedFilter.value === "custom") {
        await applyCustomFilter();
      } else {
        statisticsStore.resetData();
      }
    };

    watch(selectedFilter, onPeriodFilterChange);

    const filteredStatistics = computed(() => {
      const statistics = [
        { name: "Golfe 3", births: statisticsStore.totalBirths, deaths: statisticsStore.totalDeaths }
      ];
      if (!searchQuery.value) return statistics;

      const query = searchQuery.value.toLowerCase();
      return statistics.filter(entry => entry.name.toLowerCase().includes(query));
    });

    return {
      filteredStatistics,
      selectedFilter,
      startDate,
      endDate,
      filterOptions,
      searchQuery,
      applyCustomFilter,
      onPeriodFilterChange,
    };
  },
});
</script>

<style lang="scss" src="./mairie-page.scss" scoped />
